import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspace/$workspaceId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspace/$workspaceId/projects',
      params: { workspaceId: params.workspaceId },
    });
  },
  component: () => null,
});
